<template>
  <div class="security-wrapper">
    <div>
      <div class="trust-title">
        Security
        <img
          class="clear-icon"
          :src="require('@/assets/icons/done.svg')"
          alt="Clear icon"
        />
      </div>
      <p class="security-text">
        Security of Overnight protocol is our highest priority. All new products and features have been undergoing audits before making them
        available to the public.
        <br />
        <br />
        We are regularly cooperating with world's leading blockchain security firms ensuring the protocols safety.
      </p>
      <Divider />
    </div>
    <div class="block-audits">
      <div class="block-audits-container">
        <img
          :src="require('@/assets/audits/hacken-white.svg')"
          alt="Hacken logo"
        />
        <ButtonAudit />
      </div>
      <Divider />
    </div>
    <div class="block-audits">
      <div class="block-audits-container">
        <img
          :src="require('@/assets/audits/ackee_blue.svg')"
          alt="Ackee logo"
        />

        <ButtonAudit />
      </div>
      <Divider />
    </div>
  </div>
</template>

<script setup>
import Divider from './Divider.vue';
import ButtonAudit from './ButtonAudit.vue';
</script>

<style scoped>
.security-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border: 1px solid #0f172a;
  border-radius: 30px;
  padding: 30px 40px;
  max-width: 740px;
  width: 100%;
  height: 505px;
  box-shadow: 0 1px 0 0 #0f172a;
  background: #0497ec;

  @media only screen and (max-width: 1120px) {
    max-width: initial;
  }
  @media only screen and (max-width: 650px) {
    max-width: initial;
    height: initial;
    padding: 15px;
  }
}

.trust-title {
  font-weight: 700;
  font-size: 28px;
  text-transform: uppercase;

  @media only screen and (max-width: 768px) {
    font-size: 18px;
  }
}

.security-text {
  font-weight: 600;
  font-size: 16px;
  margin-top: 5px;
}
.block-audits {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.block-audits-container {
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: space-between;

  @media only screen and (max-width: 650px) {
    flex-direction: column;
    padding: 20px;
    gap: 20px;
    justify-content: center;
  }
}
</style>
